import React, { Component, Fragment } from 'react'
import MetaTags from 'react-meta-tags'
import Header from '../layouts/Headerinner'
import Footer from '../layouts/Footer'

const pagelocation = 'Mentions légales'
const restaurant = JSON.parse(localStorage.getItem('restaurant'))

class Mentions extends Component {
	render() {
		return (
			<Fragment>
				<MetaTags>
					<title>
						{restaurant.name} | {pagelocation}
					</title>
					<meta name='description' content='#' />
				</MetaTags>
				<Header />
				<div className='section'>
					<div className='container'>
						<div className='post-content'>
							<h2>Mentions Légales</h2>
							<h3>Hébergeur</h3>
							<p>
								SAS OVH
								<br />
								Siège Social : 2 rue Kellermann, 59100 Roubaix
								<br />
								Site Web: <a href='https://www.ovh.com'>www.ovh.com</a>
							</p>
							<h3>Editeur du site</h3>
							<p>
								SAS DRIVE EAT
								<br />
								Siège social: 82 rue du clos pasquies, 45650 Saint-Jean-le-Blanc
								<br />
								Site Web: <a href='https://drive-eat.solutions/'>https://drive-eat.solutions/</a>
							</p>
							<h3>Droits de propriété intellectuelle</h3>
							<p>
								Le site constitue une création intellectuelle dont la société DRIVE EAT est l’auteur au sens des articles L. 111.1 et
								suivants du Code de la propriété intellectuelle. L’ensemble des éléments disponibles sur le site dont notamment les
								photographies, les textes, les éventuels slogans, dessins, images, séquences animées, sonores ou non, ainsi que plus
								généralement toutes les créations intellectuelles intégrées dans le site sont la propriété de la société DRIVE EAT qui
								peut en laisser l’usage à des tiers dûment autorisés par DRIVE EAT. Par exception, certains contenus (textes, images)
								sont la propriété de leurs auteurs respectifs. Toute reproduction, représentation, utilisation, adaptation ou
								modification, par quelque procédé que ce soit et sur quelque support que ce soit, de tout ou partie du site, sans
								avoir obtenu au préalable l’autorisation de DRIVE EAT est strictement interdite et constitue un délit de contrefaçon.
								Le nom de domaine, l’appellation Drive Eat, le logo Drive Eat, sont des marques déposées par la société DRIVE EAT. Si
								d’autres marques déposées par la société DRIVE EAT viennent à être citées, elles seront identifiées par une ou des
								majuscule(s). La reproduction, la représentation, l’utilisation, l’adaptation ou la modification de ces autres marques
								sans avoir obtenu l’autorisation préalable de DRIVE EAT est strictement interdite et constitue un délit de
								contrefaçon.
							</p>
							<h3>Responsabilité</h3>
							<p>
								Le contenu du site est édité, sous réserve d’erreurs techniques et/ou typographiques, par la société Drive Eat et
								contient des photos non contractuelles. La société Drive Eat ne saurait engager sa responsabilité quant à l’exactitude
								des informations mises à disposition des internautes qui accèdent au site. La société Drive Eat ne saurait être
								responsable des dommages directs ou indirects et particulièrement de tout préjudice matériel, perte de données, et/ou
								préjudice financier qui pourrait résulter de l’utilisation du site ou des informations qui y figurent. La société
								Drive Eat ne peut garantir que le fonctionnement du site sera exempt d’interruptions ou d’erreurs. Il est rappelé que
								le fait d’accéder ou de se maintenir frauduleusement dans un système informatique, d’entraver ou de fausser le
								fonctionnement, d’introduire ou de modifier frauduleusement des données d’un tel système constitue un délit passible
								de sanctions pénales.
							</p>
							<h3>Réseaux sociaux</h3>
							<p>
								Le site utilise des liens de redirection vers des réseaux sociaux tels que Facebook et Instagram, réseaux sur lesquels
								les internautes pourront partager, sous leur responsabilité, des contenus du site ou de faire connaître à d’autres
								personnes leurs opinions concernant notamment le site. Par ailleurs, la société Drive Eat "restaurantName" utilise le
								référencement de Google My Business permettant outre la transmission d’information sur la société, la mise à
								disposition d’un lien de redirection vers le site, la localisation via l’application Google Maps et permettant aux
								internautes d’émettre un avis sur la fiche de Drive Eat. Lorsque l’utilisateur consulte une page contenant un tel
								bouton, son navigateur établit une connexion directe avec le serveur du réseau social. Si l’utilisateur est connecté
								au réseau social lors de la navigation, les boutons applicatifs vont permettre de relier les pages consultées à son
								compte utilisateur. S’il interagit au moyen de plug-in, en cliquant sur un bouton ou en laissant un commentaire, les
								informations correspondantes seront transmises au réseau social et publiées sur son compte. Cette utilisation de liens
								hypertextes ne s’applique pas aux sites Internet diffusant des informations à caractère polémique, pornographique,
								xénophobe ou pouvant, dans une large mesure, porter atteinte à la sensibilité du plus grand nombre. La société Drive
								Eat décline toute responsabilité quant au contenu des éventuels sites proposés en liens, quel que soit le type de lien
								établi à partir, ou vers le site, et la société Drive Eat se réserve le droit de s’opposer à son établissement.
							</p>
							<h3>La gestion des données personnelles</h3>
							<p>
								En France, les données personnelles sont notamment protégées par la loi n° 78-87 du 6 janvier 1978, la loi n° 2004-801
								du 6 août 2004, l’article L. 226-13 du Code pénal et la Directive Européenne du 24 octobre 1995. A l’occasion de
								l’utilisation du, des données personnelles peuvent êtres recueillis : : l’URL des liens par l’intermédiaire desquels
								l’utilisateur a accédé au site, le fournisseur d’accès de l’utilisateur, l’adresse de protocole Internet (IP) de
								l’utilisateur. En tout état de cause DRIVE EAT collecte des informations personnelles relatives à l’utilisateur que
								pour le besoin de certains services proposés par le site. L’utilisateur fournit ces informations en toute connaissance
								de cause, notamment lorsqu’il procède par lui-même à leur saisie. Il est alors précisé à l’utilisateur du site
								l’obligation ou non de fournir ces informations. Conformément aux dispositions des articles 38 et suivants de la loi
								78-17 du 6 janvier 1978 relative à l’informatique, aux fichiers et aux libertés, tout utilisateur dispose d’un droit
								d’accès, de rectification et d’opposition aux données personnelles le concernant, en effectuant sa demande écrite et
								signée, accompagnée d’une copie du titre d’identité avec signature du titulaire de la pièce, en précisant l’adresse à
								laquelle la réponse doit être envoyée. Aucune information personnelle de l’utilisateur du site n’est publiée à l’insu
								de l’utilisateur, échangée, transférée, cédée ou vendue sur un support quelconque à des tiers. Seule l’hypothèse du
								rachat de DRIVE EAT et de ses droits permettrait la transmission des dites informations à l’éventuel acquéreur qui
								serait à son tour tenu de la même obligation de conservation et de modification des données vis à vis de l’utilisateur
								du site. Les bases de données sont protégées par les dispositions de la loi du 1er juillet 1998 transposant la
								directive 96/9 du 11 mars 1996 relative à la protection juridique des bases de données.
							</p>
							<h3>Limite de responsabilité</h3>
							<p>
								En aucun cas Drive Eat ne sera tenu pour responsables de tout dommage spécifique, indirect ou direct, ou de tout
								dommage, quel qu’il soit, résultant de l’accès au site, de son utilisation, de l’impossibilité d’y accéder, de
								l’utiliser ou encore découlant de tous documents, restrictions ou recommandations et informations présentés sur ce
								site. Le présent Site pourrait contenir des liens ou des références à d’autres sites web. Internet étant géré de façon
								indépendante à travers des milliers de sites dans le monde, les informations auxquelles l’utilisateur a accès peuvent
								avoir une origine extérieure au présent site et échapper par conséquent à tout contrôle de Drive Eat. Par conséquent,
								Drive Eat n’aura aucune obligation ni aucune responsabilité concernant les contenus disponibles et accessibles sur le
								Site, par l’intermédiaire du Site ou en dehors du Site. L’utilisateur s’engage à ne pas modifier, intégrer ni
								remplacer, en tout ou en partie, les informations présentées par Drive Eat sur le présent Site.
							</p>
							<h3>Remarques et communications</h3>
							<p>
								Les informations transmises « au site » (par courrier, courrier électronique ou par tout autre moyen) ne pourront être
								considérées comme confidentielles. DRIVE EAT est seul destinataire des informations transmises « au site».
								Conformément à la loi du 06/01/1978 I’ internaute dispose d’un droit d’accès, de rectification et d’opposition aux
								informations le concernant qu’il peut exercer à tout moment auprès de : DRIVE EAT, 82 Rue du clos pasquies – 45650
								Saint-Jean-le-Blanc Drive Eat sera heureux de recevoir les remarques des utilisateurs sur le site ainsi que sur ses
								services, mais il est bien entendu qu’elle ne sollicite aucune suggestion, aucune idée ni aucun matériel relatif au
								développement, à la conception, à la fabrication ou au marketing desdits produits.
							</p>
							<h3>Législation et juridiction compétente</h3>
							<p>
								Les présentes Conditions seront régies interprétées et appliquées selon la loi française, sauf indication contraire
								affichée sur le site. Tout litige résultant de l’interprétation et de l’application des dites Conditions sera de la
								compétence exclusive des Tribunaux d'ORLEANS, sauf indication contraire affichée sur le site.
							</p>
						</div>
					</div>
				</div>
				<Footer
					footer={{
						style: 'ct-footer footer-dark',
						logo: 'assets/img/logo-light.png',
					}}
				/>
			</Fragment>
		)
	}
}

export default Mentions
